(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tc-click-effects"] && !Shopify.designMode) return;
  try {
    const layer = document.getElementById('tc-click-effect-layer');
  if (layer && layer.dataset.ready !== 'true') {
    layer.dataset.ready = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const compact = window.matchMedia('(pointer: coarse)');
    const controller = new AbortController();
    const active = new Map();

    const removeBurst = (burst) => {
      clearTimeout(active.get(burst));
      active.delete(burst);
      burst.remove();
    };

    const clearBursts = () => {
      for (const burst of active.keys()) removeBurst(burst);
    };

    document.addEventListener('click', (event) => {
      if (reducedMotion.matches || event.button !== 0 || !layer.isConnected) return;
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      if (!target) return;
      const dialog = target.closest('dialog[open]');
      const host = dialog || document.body;
      if (layer.parentElement !== host) {
        clearBursts();
        host.append(layer);
      }
      const rect = event.detail === 0 ? target.getBoundingClientRect() : null;
      const x = rect ? rect.left + rect.width / 2 : event.clientX;
      const y = rect ? rect.top + rect.height / 2 : event.clientY;
      const origin = layer.getBoundingClientRect();
      const burst = document.createElement('div');
      burst.className = 'tc-click-effect-burst';
      burst.style.left = `${x - origin.left}px`;
      burst.style.top = `${y - origin.top}px`;
      const darkArea = target.closest('header, header-component, footer, .hero, [id*="tc3d"], [class*="tc3d"]');
      if (darkArea) burst.style.setProperty('--tc-click-color', '#9ff0d9');
      for (const className of ['tc-click-effect-ring', 'tc-click-effect-ring tc-click-effect-ring--inner', 'tc-click-effect-core']) {
        const element = document.createElement('span');
        element.className = className;
        burst.append(element);
      }
      const count = compact.matches ? 8 : 10;
      for (let index = 0; index < count; index += 1) {
        const angle = (index / count) * Math.PI * 2;
        const distance = 30 + (index % 3) * 9;
        const particle = document.createElement('span');
        particle.className = 'tc-click-effect-particle';
        particle.style.setProperty('--tc-click-x', `${Math.cos(angle) * distance}px`);
        particle.style.setProperty('--tc-click-y', `${Math.sin(angle) * distance}px`);
        burst.append(particle);
      }
      if (active.size >= 8) removeBurst(active.keys().next().value);
      layer.append(burst);
      active.set(burst, setTimeout(() => removeBurst(burst), 1000));
    }, { capture: true, passive: true, signal: controller.signal });

    reducedMotion.addEventListener('change', clearBursts, { signal: controller.signal });
    window.addEventListener('pagehide', (event) => {
      clearBursts();
      if (!event.persisted) controller.abort();
    }, { signal: controller.signal });
  }
  } catch(e) { console.error(e); }
})();

})();
